//dummy
export const getDummyAdditionalContextTemplates = () => [
  {
    id: 'act-1',
    content: 'Template 1 content',
  },
  {
    id: 'act-2',
    content: 'Template 2 content',
  },
  {
    id: 'act-3',
    content: 'Template 3 content',
  },
  {
    id: 'act-4',
    content: 'Template 4 content',
  },
];

// Get templates from Redux or return dummy data
export const getAdditionalContextTemplates = (reduxTemplates = []) => {
  if (Array.isArray(reduxTemplates) && reduxTemplates.length > 0) {
    return reduxTemplates;
  }
  return getDummyAdditionalContextTemplates();
};

// Filter templates by search query
export const filterAdditionalContextTemplates = (templates, searchQuery) => {
  if (!searchQuery || !searchQuery.trim()) return templates;
  
  const query = searchQuery.toLowerCase();
  return templates.filter(template => {
    if (!template || typeof template !== 'object') return false;
    const name = template.name || '';
    const content = template.content || '';
    return name.toLowerCase().includes(query) || content.toLowerCase().includes(query);
  });
};

// Sort templates
export const sortAdditionalContextTemplates = (templates, sortBy) => {
  const sorted = [...templates];
  
  switch (sortBy) {
    case 'name-asc':
      return sorted.sort((a, b) => {
        const nameA = (a?.name || '').toLowerCase();
        const nameB = (b?.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    case 'name-desc':
      return sorted.sort((a, b) => {
        const nameA = (a?.name || '').toLowerCase();
        const nameB = (b?.name || '').toLowerCase();
        return nameB.localeCompare(nameA);
      });
    case 'content-asc':
      return sorted.sort((a, b) => {
        const contentA = (a?.content || '').toLowerCase();
        const contentB = (b?.content || '').toLowerCase();
        return contentA.localeCompare(contentB);
      });
    case 'content-desc':
      return sorted.sort((a, b) => {
        const contentA = (a?.content || '').toLowerCase();
        const contentB = (b?.content || '').toLowerCase();
        return contentB.localeCompare(contentA);
      });
    default:
      return sorted;
  }
};

